<div class="scroll-content">
  <div class="upsellDownsell upsell-page">
    <div class="upDownPage">
      <ng-container *ngFor="let content of pageContents; let i = index; trackBy: trackByIndex">
        <ng-container [ngSwitch]="content.type">
          <ng-container *ngSwitchCase="'component'">
            <ng-container [ngSwitch]="content.componentName">
              <ng-container *ngSwitchCase="'upsell-header'">
                <upsell-header [dynamicPhoneNumber]="dynamicPhoneNumber" class="{{ content.class }}"></upsell-header>
              </ng-container>
              <ng-container *ngSwitchCase="'progress-bar'">
                <progress-bar *ngIf="totalProductsSummary" [total]="minForFreeShipping"
                [current]="totalProductsSummary" [title]="progressBarTitle" [logo]="progressBarLogo"
                [subTitle]="progressBarSubTitle" [customText]="progressBarCustomText" class="{{ content.class }}"></progress-bar>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-sticky-bar'">
                 <upsell-sticky-bar [brand]="content.options.productBrand || productBrand"
                  [name]="content.options.productName || productName" [image]="productImage"
                  [quantity]="productQuantity" [total]="productYourPrice" [productUnitType]="productUnitType"
                  [addToCartText]="content.options.addToCartText" (eventEmitter)="nextPage($event)"
                  [buttonYesText]="buttonYesText"
                  [buttonNoText]="buttonNoText"
                  [description]="guarantee_01_description"
                  [upsellCtaTextButtonsClass]="guarantee_01_upsellCtaTextButtonsClass"
                ></upsell-sticky-bar> 
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-sticky-bar-v2'">
                <upsell-sticky-bar-v2 [productBrand]="productBrand" [productName]="productName" [productImage]="productImage" [productYourPrice]="productYourPrice"
                  [ngClass]="content.class" [productQuantity]="productQuantity" [total]="productYourPrice"
                  [productUnitType]="productUnitType" [addToCartText]="stickyBarAddToCartText"
                  (itemAdded)="nextPage($event)" (eventEmitter)="nextPage($event)" [currency]="currency" class="{{ content.class }}">
                </upsell-sticky-bar-v2>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-steps'">
                <upsell-steps *ngIf="steps_show" [steps]="steps_items" [stepLabel]="step_label"
                [showNumbers]="showNumbers" [newStepsStyle]="content.options?.newStepsStyle || false" class="{{ content.class }}">
                </upsell-steps>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-wait'">
                <upsell-wait *ngIf="wait_show" [isFull]="wait_isFull" [title]="wait_title"
                [description]="wait_description" [iconText]="wait_text" [iconWait]="iconImgWait" class="{{ content.class }}">
                </upsell-wait>
              </ng-container>
              <ng-container *ngSwitchCase="'video-player'">
                <video-player 
                  [videoID]="videoID" 
                  [videoClass]="videoClass"
                  [videoThumbnail]="videoThumbnail"
                  [videoPlayType]="videoPlayType"
                  class="{{ content.class }}"
                >
                </video-player>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-section'">
                <upsell-section [ngClass]="content.class" [content]="content.options"></upsell-section>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-why'">
                 <upsell-why [upsellWhyContent]="content.options" [upsellWhyImage]="upsellWhyImage" class="{{ content.class}}"></upsell-why> 
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-faq'">
                 <upsell-faq [upsellFaqContent]="content.options" [upsellFaqTitle]="upsellFaqTitle" class="{{ content.class}}"></upsell-faq> 
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-product-box'">
                <upsell-product-box [currency]="currency"
                [braintreeCurrencyConversion]="braintreeCurrencyConversion" [currencySymbol]="currencySymbol"
                [officialCurrency]="officialCurrency" [productBoxTitle]="productBoxTitle"
                [image]="productImage" [imageAlt]="productTitle"
                [productBoxSubtitle]="productBoxSubtitle" [regularPrice]="productRegularPrice"
                [instantSavings]="productInstantSavings" [yourPriceText]="product_box_yourPriceText"
                [instantSavingsText]="product_box_instantSavingsText" [regularText]="product_box_regularText"
                [yourPrice]="productYourPrice"
                [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productBoxCTA]="productBoxCTA" 
                (eventEmitter)="nextPage($event)" class="{{ content.class }}">
                </upsell-product-box>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-product-box-tbyb'">
                <upsell-product-box-tbyb [currency]="currency"
                [productName]="productName" [mbgDays]="mbgDays"
                [braintreeCurrencyConversion]="braintreeCurrencyConversion" [currencySymbol]="currencySymbol"
                [officialCurrency]="officialCurrency" [productBoxTitle]="productBoxTitle"
                [image]="productImage" [imageAlt]="productTitle"
                [productBoxSubtitle]="productBoxSubtitle" [regularPrice]="productRegularPrice"
                [instantSavings]="productInstantSavings" [yourPriceText]="product_box_yourPriceText"
                [instantSavingsText]="product_box_instantSavingsText" [regularText]="product_box_regularText"
                [yourPrice]="productYourPrice" [productPercent]="productPercent" [totalProductsSummary]="totalProductsSummary" [reviewCount]="reviewCount"
                [currentUpsellTax]="taxRate?.totalTax || 0"
                [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productBoxCTA]="productBoxCTA" 
                (eventEmitter)="nextPage($event)" class="{{ content.class }}">
                </upsell-product-box-tbyb>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-product-box-full'">
                <upsell-product-box-full [currency]="currency"
                [braintreeCurrencyConversion]="braintreeCurrencyConversion" [currencySymbol]="currencySymbol"
                [officialCurrency]="officialCurrency" [title]="product_box_full_title" [image]="productImage"
                [imageAlt]="productTitle" [additionalImage]="product_box_full_additionalImage"
                [yourPriceText]="product_box_yourPriceText" [instantSavingsText]="product_box_instantSavingsText"
                [regularText]="product_box_regularText" [regularPrice]="productRegularPrice"
                [instantSavings]="productInstantSavings" [yourPrice]="productYourPrice" class="{{ content.class }}"></upsell-product-box-full>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-wait-rectangular'">
                <upsell-wait-rectangular [isFull]="wait_isFull" [title]="wait_title" [description]="wait_description"
                [iconText]="wait_text" [iconWait]="iconImgWait" class="{{ content.class }}"></upsell-wait-rectangular>
              </ng-container>
              <ng-container *ngSwitchCase="'vidalytics-video'">
                <video-player-vidalytics [vidalyticsEmbedId]="vidalyticsConfig.vidalyticsEmbedId"  class="{{ content.class }}"> </video-player-vidalytics>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-mbg'">
                <upsell-mbg [mbgCTA]="mbgCTA"  [mbgDays]="mbgDays"  [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productName]="productName" [mbgText]="mbgText" class="{{ content.class }}" (eventEmitter)="nextPage($event)"></upsell-mbg> 
              </ng-container> 
              <ng-container *ngSwitchCase="'upsell-doc'">
                <upsell-doc [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productName]="productName" [docText]="docText" class="{{ content.class }}" (eventEmitter)="nextPage($event)"></upsell-doc> 
              </ng-container> 
              <ng-container *ngSwitchCase="'upsell-cta'">
                <upsell-cta [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productName]="productName" class="{{ content.class }}" (eventEmitter)="nextPage($event)"></upsell-cta> 
              </ng-container>
              <ng-container *ngSwitchCase="'brand-reviews'">
                <brand-reviews [reviewsTitle]="content.options?.reviewsTitle || reviewsTitle" 
                              [reviews]="content.options?.reviews"
                              [perReviewAddOn]="content.options?.perReviewAddOn || perReviewAddOn" class="{{ content.class }}"></brand-reviews>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-modal'">
                <upsell-modal
                  [show]="showModal"
                  [title]="content.options.title"
                  [message]="content.options.message"
                  [buttonText]="content.options.buttonText"
                  (close)="closeModal()"
                  (cta)="onModalCTA()"
                  [upsellModalInputs]="{
                    title: content.options.title,
                    message: content.options.message,
                    buttonText: content.options.buttonText,
                    html: content.options.html
                  }"
                ></upsell-modal>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-offer-spinner'">
                <upsell-offer-spinner-v2
                  [title]="optionsSpinner?.title"
                  [description]="optionsSpinner?.description"
                  [spinButtonText]="optionsSpinner?.spinButtonText"
                  [spinnedTitle]="optionsSpinner?.spinnedTitle"
                  [spinnedDescription]="optionsSpinner?.spinnedDescription"
                  [spinnedButtonText]="optionsSpinner?.spinnedButtonText"
                  [declineButtonText]="optionsSpinner?.declineButtonText"
                  [wheelCenterImage]="optionsSpinner?.wheelCenterImage"
                  [wheelOptions]="optionsSpinner?.wheelOptions"
                  [pointerAngle]="optionsSpinner?.pointerAngle"
                  [closeAfterSpinTime]="optionsSpinner?.closeAfterSpinTime"
                ></upsell-offer-spinner-v2>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-footer'">
                <upsell-footer class="{{ content.class }}" [footerLinks]="footerLinks" [footerText]="footerText" [brand]="productBrand"
                [address]="footerAddress"></upsell-footer>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'html'">
            <div class="{{ content.name }}" [innerHTML]="content.html">
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>